<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import Checkout from 'components/Checkout'
import inventoryService from 'api/inventory'
import venueService from 'api/venue'

export default {
  name: 'express-checkout',
  data() {
    return {
      loading: true,
      inventoryId: this.$route.query.inventoryId,
      inventory: null,
      attributionId: this.$route.query.attributionId,
      quantity: parseInt(this.$route.query.quantity || 1, 10),
      client: this.$route.query.client || 'web-fast-pass',
    }
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
    }),
    disableQuantity() {
      return this.client === 'payment-link'
    },
  },
  components: {
    Checkout,
  },
  methods: {
    getInventory() {
      return inventoryService
        .getById(this.inventoryId)
        .then((result) => {
          this.inventory = result

          return this.$store.dispatch('addCartItem', {
            inventoryId: this.inventory.id,
            quantity: this.quantity || 1,
          })
        })
        .catch((err) => {
          this.loading = false

          throw err
        })
    },
    getVenue() {
      return venueService.getById(this.inventory.venue).then((result) => {
        this.$store.dispatch('setCurrentVenue', result.data)
      })
    },
  },
  mounted() {
    this.loading = true

    Promise.all([this.getInventory(), this.$store.dispatch('setConfigAttributionId', this.attributionId), this.$store.dispatch('setConfigClient', this.client)])
      .then(() => {
        return this.getVenue()
      })
      .then(() => {
        this.loading = false

        return null
      })
  },
  metaInfo() {
    let pageTitle = 'Purchase tickets, cover and VIP table packages'
    const pageDescription = 'The fastest, most frictionless way to take payments at your door.'

    if (this.venue) {
      pageTitle += ` at ${this.venue.name} | TablelistPro Fast Pass`
    }

    return {
      title: pageTitle,
      meta: [
        {
          property: 'og:title',
          content: pageTitle,
        },
        {
          property: 'og:description',
          content: pageDescription,
        },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/ExpressCheckout/index.vue